<div class="user-menu" (keydown.escape)="close()">
  <button
    class="avatar-btn"
    (click)="toggle()"
    [attr.aria-expanded]="open()"
    aria-haspopup="true"
    aria-label="Menu do usuário">
    <span class="avatar" aria-hidden="true">{{ userInitials() }}</span>
    <span class="user-identity">
      <span class="user-name">{{ user()?.nome || 'Usuário' }}</span>
      <span class="user-role">{{ user()?.role || '—' }}</span>
    </span>
    <svg class="chevron" [class.open]="open()" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M3 5L7 9L11 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  @if (open()) {
    <div class="menu-backdrop" (click)="close()" aria-hidden="true"></div>

    <div class="user-dropdown" role="menu" aria-label="Opções do usuário">
      <div class="user-dropdown-header">
        <span class="avatar avatar-lg" aria-hidden="true">{{ userInitials() }}</span>
        <div class="user-info">
          <span class="user-info-name">{{ user()?.nome }}</span>
          <span class="user-info-email">{{ user()?.email }}</span>
        </div>
      </div>

      <div class="user-dropdown-divider" role="separator"></div>

      <ul class="user-dropdown-menu" role="none">
        <li role="none">
          <button class="dropdown-item" role="menuitem" (click)="onSwitchCompany()">
            <svg width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true"><rect x="3" y="2" width="9" height="14" stroke="currentColor" stroke-width="1.6"/><rect x="12" y="7" width="3" height="9" stroke="currentColor" stroke-width="1.6"/></svg>
            Trocar empresa
          </button>
        </li>

        @if (canAccessAdmin()) {
          <li role="none">
            <button class="dropdown-item" role="menuitem" (click)="onGoToAdmin()">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <rect x="1" y="1" width="6" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
                <rect x="9" y="1" width="6" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
                <rect x="1" y="9" width="6" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
                <path d="M12 9V15M9 12H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              Acesso administrativo
            </button>
          </li>
        }

        <li role="none">
          <button class="dropdown-item dropdown-item-danger" role="menuitem" (click)="onLogout()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M6 2H3C2.448 2 2 2.448 2 3V13C2 13.552 2.448 14 3 14H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M10 5L14 8M14 8L10 11M14 8H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Sair
          </button>
        </li>
      </ul>
    </div>
  }
</div>
